/* eslint-disable jira/filename-case */
import type { ComponentType } from 'react';
import type { ReactGadgetProps } from '@jira/global-pages__dashboard-react-gadgets-common/src/types.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { CustomReportGadgetData } from '../../common/types.tsx';

export const LazyCustomReportGadgetEdit: LazyComponent<
	ComponentType<ReactGadgetProps<CustomReportGadgetData>>
> = lazyForPaint<ComponentType<ReactGadgetProps<CustomReportGadgetData>>>(
	() => import(/* webpackChunkName: "async-react-custom-report-gadget-edit" */ './main.tsx'),
);
